import React from 'react';
import { Briefcase, Calendar } from 'lucide-react';
import { mockExperience } from '../mock';

const Experience = () => {
  return (
    <section id="experience" className="relative py-24 bg-gradient-to-b from-black/30 to-transparent">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Experience</h2>
          <div className="w-20 h-1 bg-cyan-500 mx-auto"></div>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-px bg-cyan-500/30 transform md:-translate-x-1/2"></div>

          <div className="space-y-12">
            {mockExperience.map((exp, index) => (
              <div
                key={exp.id}
                className={`relative flex flex-col md:flex-row items-start md:items-center gap-8 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Timeline dot */}
                <div className="absolute left-8 md:left-1/2 w-4 h-4 bg-cyan-500 rounded-full border-4 border-black transform md:-translate-x-1/2 z-10">
                  {exp.current && (
                    <div className="absolute inset-0 rounded-full bg-cyan-500 animate-ping"></div>
                  )}
                </div>

                {/* Content card */}
                <div className="flex-1 ml-20 md:ml-0 md:w-5/12">
                  <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-6 hover:bg-white/10 hover:border-cyan-500/50 transition-all duration-300">
                    <div className="flex items-center gap-2 mb-3">
                      <Briefcase size={20} className="text-cyan-400" />
                      <h3 className="text-xl font-semibold text-white">{exp.title}</h3>
                    </div>
                    <p className="text-cyan-400 font-medium mb-2">{exp.company}</p>
                    <div className="flex items-center gap-2 text-white/60 text-sm mb-4">
                      <Calendar size={16} />
                      <span>{exp.period}</span>
                    </div>
                    <p className="text-white/70 leading-relaxed">{exp.description}</p>
                    {exp.current && (
                      <span className="inline-block mt-3 px-3 py-1 bg-cyan-500/20 text-cyan-400 text-xs font-medium rounded-full border border-cyan-500/30">
                        Current
                      </span>
                    )}
                  </div>
                </div>

                {/* Spacer for alternating layout */}
                <div className="hidden md:block md:w-5/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;